import tomoyanagishita63png from '../images/tomoyanagishita63.png'

// プロフィール情報を保存する配列
export const profdata: { [key: string]: { [key: string]: string } } = {
  prof: {
    name: 'きむ',
    avatarimage: '',
    profession: 'インスタグラマー',
    intro:
      '写真を撮ることが好きです！UI/UXデザイン修行中。<br/>最近買ったものでおすすめは富士フィルムのX-E4。めちゃくちゃ良いスナップ用カメラです。毎日持って出掛けたくなる、、（投稿でも紹介してます！）',
    instagram: 'selectbook',
    tiktok: 'ja-JP',
    twitter: 'select_book',
  },
  tano: {
    name: 'たのっち',
    avatarimage: '',
    profession: 'YouTuber',
    intro: 'たのっち、YouTuberやってます！',
    instagram: 'selectbook',
    tiktok: '',
    twitter: 'select_book',
  },
  tomoyanagishita63: {
    name: '柳下大',
    avatarimage: tomoyanagishita63png,
    profession: 'コンサルタント/代表取締役社長',
    intro:
      '元々俳優を13年ほど経験し、現在はコンサル会社で社長してます。様々なことに興味があり、実際に体験、体感して良いと思ったモノのみご紹介していきます！',
    instagram: 'tomo_yanagishita63/',
    tiktok: '',
    twitter: 'tomoyanagishita',
    ts: '2022/01/12 11:10:16',
  },
}
